'use strict';
 /**
 * @author Maxim Seredkin
 */
import angular from "angular";
import ProjectPlanFundModalCreate from "./controller/planFundModalCreate";
import ProjectPlanFundTableDirective from "./directive/projectPlanFundTable";

export default angular.module('investmentProject.project.fund.plan', [])
    .controller('ProjectPlanFundModalCreateController', ProjectPlanFundModalCreate)
    .directive('projectPlanFundTable', ProjectPlanFundTableDirective)
    .name;